import React from "react";
import styles from "./styles/OutputScofflaw.module.css";
import { ReactComponent as IconScofflaw } from "../../../assets/scofflaw.svg";
/**
 * Info output window component
 * Used in ticket info section in the search page
 */
const OutputScofflaw = ({ header, body }) => {
    return (
        <div className={`${styles.main_info_container} flex-container`}>
            <div className={`${styles.alert}`}></div>
            <IconScofflaw className={`${styles.icon} icon-component`} />

            <div className={`${styles.info_container}`}>
                <h3
                    className={`
                      
                        ${styles.info_header}`}
                >
                    {header}
                </h3>

                <div className={`${styles.info_body} `}>{body}</div>
            </div>
        </div>
    );
};

export default OutputScofflaw;
